/* eslint-disable security/detect-object-injection */

import { Avatar, Card, Popover, Spin } from 'antd'
import Meta from 'antd/lib/card/Meta'
import { find, get, includes, map } from 'lodash'
import LoadingSpinner from '@/screens/Order/components/LoadingComponent/LoadingSpinner'
import { MailOutlined, PhoneOutlined } from '@ant-design/icons'
import { useQuery } from 'react-query'
import { getCollaboratorsForTasks } from '@/screens/Order/Pages/Order.transform'
import { getUrlParams } from '@/utils/common'

const _replaceMentionComment = function (string, find) {
  let replaceString = string
  for (let i = 0; i < find.length; i++) {
    replaceString = replaceString.replace(
      find[i],
      "<p style='display: inline-block;color: #0075bd;'>" +
        find[i].substring(1) +
        '</p>'
    )
  }
  return replaceString
}

function ReplaceMentionCommentElement(prop: {
  string: string
  find: string[]
  mentions: any[]
  task: any
}) {
  const { data: contributers, isLoading } = useQuery(
    'GET_COLLABORATOR_FOR_MENTION',
    async () => {
      return await getCollaboratorsForTasks(
        getUrlParams('orderKey') ?? prop.task?.order?.id
      )
    }
  )

  var words: any[] = prop.string ? prop.string.split(' ') : []

  const getUser = (id, mentioned) => {
    return get(
      find(
        map(contributers, (contributer) => {
          return {
            ...contributer,
            exist: includes(prop.mentions, contributer?.id),
          }
        }),
        {
          user: { first_name: mentioned.substring(1) },
        }
      ),
      'user'
    )
  }

  if (isLoading) return <div />

  let result: JSX.Element = (
    <>
      {words.map((word, index) => {
        if (/@[A-Za-z0-9_-]*/g.test(word))
          return (
            <Popover
              key={index}
              placement="bottom"
              content={
                <div className="comment-user-popover-name">
                  <Spin spinning={false} indicator={<LoadingSpinner />}>
                    <Card className="p-2" bordered={false}>
                      <Meta
                        avatar={
                          <Avatar
                            src={
                              (getUser(contributers[0]?.id, word) as any)
                                ?.avatar?.url_path
                            }
                          >
                            {
                              (getUser(contributers[0]?.id, word) as any)
                                ?.first_name
                            }
                          </Avatar>
                        }
                        title={`${
                          (getUser(contributers[0]?.id, word) as any)
                            ?.first_name
                        } ${
                          (getUser(contributers[0]?.id, word) as any)?.last_name
                        }`}
                      />

                      {/* <p>{`${
                        (getUser(contributers[0]?.id, word) as any)
                          ?.property_value?.value?.length &&
                        find(
                          (getUser(contributers[0]?.id, word) as any)
                            ?.property_value?.value,
                          ['key', 'position']
                        )?.value
                      }`}</p> */}

                      <div style={{ marginTop: 15 }}>
                        <p>
                          <PhoneOutlined /> &nbsp;
                          <a
                            href={`tel:${
                              find(
                                (getUser(contributers[0]?.id, word) as any)
                                  ?.property_value?.value,
                                ['key', 'phoneNumber']
                              )?.value ?? 'N/A'
                            }`}
                          >
                            {find(
                              (getUser(contributers[0]?.id, word) as any)
                                ?.property_value?.value,
                              ['key', 'phoneNumber']
                            )?.value ?? 'N/A'}
                          </a>
                        </p>

                        <p>
                          <MailOutlined /> &nbsp;
                          <a
                            href={`mailto:${
                              (getUser(contributers[0]?.id, word) as any)
                                ?.email ?? 'N/A'
                            }`}
                          >
                            {(getUser(contributers[0]?.id, word) as any)
                              ?.email ?? 'N/A'}
                          </a>
                        </p>
                      </div>
                    </Card>
                  </Spin>
                </div>
              }
            >
              <p
                style={{
                  display: 'inline-block',
                  color: '#0075bd',
                  cursor: 'pointer',
                }}
              >
                {' '}
                {word}
              </p>
            </Popover>
          )
        else return <> {word}</>
      })}
    </>
  )

  return result
}

export const getDisplayComment = (comment) => {
  var pattern = /@[A-Za-z0-9_-]*/g
  var mentionedUserEmail = comment.match(pattern)

  return _replaceMentionComment(comment, mentionedUserEmail)
}

export const getCommentDisplayElement = (comment, mentions: any[], task) => {
  var pattern = /@[A-Za-z0-9_-]*/g
  var mentionedUserEmail: string[] =
    comment !== null ? comment.match(pattern) : []

  return (
    <>
      <ReplaceMentionCommentElement
        string={comment}
        find={mentionedUserEmail}
        mentions={mentions}
        task={task}
      />
    </>
  )
}
